import type { UserCard } from "@/queries/models"

export const WTP_NUMBER_FORMAT = "XXXXXXXX-XXX-XXX"

export const isWtpFormatValid = (wtpNumber: string) => {
  // 8 uppercase alphanumerics, then - or /, 3 alphanumerics, dash, 3 alphanumerics
  const regex = /^[A-Z0-9]{8}[-/][A-Z0-9]{3}-[A-Z0-9]{3}$/
  return regex.test(wtpNumber)
}

export const isUserProfileCard = (userCards: UserCard[], wtpNumber: string) =>
  userCards.some((card) => card.wtpNumber === wtpNumber)
